import { createSelector } from 'reselect';

import { getHasOpenActivity } from 'lib/selectors/getHasOpenActivity';
import { getOEEMetrics } from 'lib/selectors/getOEEMetrics';

/*
  calculating availability: https://machinemetrics.quip.com/bDM9AOj7yo6q
  availability: scheduledTimeInCycle / scheduledTime

  We are now using the production API for availability, so we no longer need to calculate it here
*/

const getAvailabilityDecimal = createSelector(
  [getHasOpenActivity, getOEEMetrics],
  (hasOpenActivity, oeeMetrics) => {
    if (!hasOpenActivity) {
      // metric is only relevant when active / job is running and unpaused
      return null;
    }
    return oeeMetrics?.availability || null;
  }
);

export { getAvailabilityDecimal };
